
import { Component, Vue } from 'vue-property-decorator'
import { apiWxOpenPlatformConfigGet, apiWxOpenPlatformConfigSet } from '@/api/wxopen'

@Component
export default class WxOpenPlatformSetting extends Vue {
  form: any = {
    app_id: '',
    app_secret: '',
    token: '',
    aes_key: '',
    has_ticket: false,
    ticket_updated_at_text: '',
    component_notify_url: '',
    authorizer_notify_url: '',
    auth_callback_url: ''
  }

  rules = {
    app_id: [{ required: true, message: '请填写 AppID', trigger: 'blur' }],
    app_secret: [{ required: true, message: '请填写 AppSecret', trigger: 'blur' }]
  }

  async loadConfig () {
    const res = await apiWxOpenPlatformConfigGet()
    this.form = { ...this.form, ...res }
  }

  onSubmit (formName: string) {
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate(async (valid: boolean) => {
      if (!valid) return
      await apiWxOpenPlatformConfigSet({
        app_id: this.form.app_id,
        app_secret: this.form.app_secret,
        token: this.form.token,
        aes_key: this.form.aes_key
      })
      this.$message.success('保存成功')
      this.loadConfig()
    })
  }

  copyText (text: string) {
    if (!text) return
    navigator.clipboard.writeText(text).then(() => {
      this.$message.success('已复制')
    }).catch(() => {
      this.$message.error('复制失败，请手动复制')
    })
  }

  created () {
    this.loadConfig()
  }
}
